/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  alpha,
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Typography,
} from '@mui/material';
import { DesktopDatePicker, DesktopTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ChangeEvent, useContext, useEffect } from 'react';
import { PatternFormat } from 'react-number-format';

import {
  convertClientKind,
  convertEvaluationType,
  convertPropertyType,
  InspectionType,
} from '../../api/enumerations';
import { AllAttachments } from '../../components/AllAttachments';
import ConfirmationDeleteDialog from '../../components/ConfirmationDeleteDialog';
import ConfirmationDialog from '../../components/ConfirmationDialog';
import {
  CustomTextField,
  NumericTextField,
  SelectTextField,
} from '../../components/CustomInput';
import StandardMap from '../../components/Maps/StandardMap';
import MapSearchButton from '../../components/MapSearchButton';
import { MessagesDialog } from '../../components/Messages';
import { PeptDialog } from '../../components/PeptDialog';
import { AccordionTitle } from '../../components/Sections/AccordionTitle';
import { AssociatedWorkOrders } from '../../components/Sections/AssociatedWorkOrders';
import { ClientData } from '../../components/Sections/ClientData';
import { HiveDeadlineBar } from '../../components/Sections/HiveDeadlineBar';
import { WorkOrderProgressBar } from '../../components/Sections/ProgressBar';
import { PropertyAddressWithMaps } from '../../components/Sections/PropertyAddressWithMaps';
import { PropertyData } from '../../components/Sections/PropertyData';
import { PropertyInfo } from '../../components/Sections/PropertyInfo';
import { ScheduleInfo } from '../../components/Sections/ScheduleInfo';
import { Title } from '../../components/Sections/Title';
import { ToogleAccordion } from '../../components/Sections/ToogleAccordion';
import Snackbar from '../../components/Snackbar';
import {
  BoxContainer,
  CancelOsBox,
  FlexBox,
  FlexSpaceBetweenBox,
  LoadingBox,
  SectionBox,
} from '../../components/UI/Box';
import { BackButton, DownloadButton } from '../../components/UI/Button';
import { GridContainer } from '../../components/UI/Grid';
import {
  ColoredCircularProgress,
  StyledTextField,
  textFieldDefaultStyle,
} from '../../components/UI/Typography';
import {
  IconApartmentMS,
  IconArrowCircleLeftMS,
  IconCalendarTodayMS,
  IconDownloadMS,
  IconEditNoteMS,
  IconLocationCityMS,
  IconLocationOnMS,
  IconPersonMS,
  IconUploadMS,
} from '../../constants/icons';
import { Constants } from '../../constants/schedule';
import {
  parcelGroup,
  privateUnitsGroup,
  selectConcept,
  selectConservation,
  selectPropertyUse,
  selectRegistrationUf,
  selectReportFunction,
  selectReportGoal,
  selectStandard,
} from '../../constants/selectOptions';
import { GlobalContext } from '../../context/global';
import { formatPhone } from '../../helpers';
import { useAccordion } from '../../hooks/useAccordion';
import { useCancelWorkOrder } from '../../hooks/useCancelWorkOrder';
import { useChangeStatus } from '../../hooks/useChangeStatus';
import useGeneral from '../../hooks/useGeneral';
import { Banner } from './Banner';
import Calendar from './Calendar';
import { RemoteInspectionTableHistory } from './RemoteInspectionTableHistory';
import {
  ButtonBox,
  ButtonContainer,
  ButtonTitle,
  CepStyle,
  ConfirmEditButton,
  EditButton,
  InputTitle,
  OutlineButton,
  SectionTitle,
  StyledInput,
  SubmitBox,
  UploadButton,
} from './styles';
import useSchedule from './useSchedule';

export function Schedule(): JSX.Element {
  const { openSnackbar, isHiveOwner } = useContext(GlobalContext);
  const { handleCancelWorkOrder } = useCancelWorkOrder();
  const { handleStatus, loadingApprove, setLoadingApprove } = useChangeStatus();
  const { osId, navigateHome, handleDownloadFile } = useGeneral();
  const {
    expandOne,
    setExpandOne,
    expandTwo,
    setExpandTwo,
    expandThree,
    setExpandThree,
    expandFour,
    setExpandFour,
    expandAll,
    setExpandAll,
    toggleAccordions,
  } = useAccordion();
  const {
    propertyData,
    engineer,
    setEngineer,
    usersData,
    responsibleName,
    setResponsibleName,
    contact,
    setContact,
    date,
    setDate,
    startTime,
    endTime,
    hasSchedule,
    scheduledData,
    address,
    setAddress,
    addressNumber,
    setAddressNumber,
    isWithoutNumber,
    setIsWithoutNumber,
    age,
    setAge,
    buildingStandard,
    setBuildingStandard,
    builtArea,
    setBuiltArea,
    cep,
    city,
    setCity,
    client,
    setClient,
    complement,
    setComplement,
    concept,
    setConcept,
    conservation,
    setConservation,
    district,
    setDistrict,
    goal,
    setGoal,
    judicialDistrict,
    setJudicialDistrict,
    parkingLots,
    setParkingLots,
    propertyFunction,
    setPropertyFunction,
    propertyUse,
    setPropertyUse,
    registerNumber,
    setRegisterNumber,
    registryOffice,
    setRegistryOffice,
    book,
    setBook,
    registrationUf,
    setRegistrationUf,
    propertyRooms,
    setPropertyRooms,
    solicitor,
    setSolicitor,
    suites,
    setSuites,
    toilets,
    setToilets,
    totalArea,
    setTotalArea,
    uf,
    setUf,
    zone,
    setZone,
    registerFileName,
    iptuFileName,
    searchMap,
    setSearchMap,
    isAddressEdited,
    setIsAddressEdited,
    hasSearched,
    setHasSearched,
    pinPlace,
    setPinPlace,
    enableEditing,
    setEnableEditing,
    today,
    getEngineerEvents,
    handleStartTime,
    handleEndTime,
    handleSchedule,
    handleScheduleExist,
    handleSubmit,
    verifyCep,
    handleFileUpload,
    loadingPage,
    downloadIptu,
    downloadRegister,
    completeScheduling,
  } = useSchedule();

  const isParcelGroup =
    propertyData && parcelGroup.has(propertyData?.real_estate_kind);
  const isPrivateUnit =
    propertyData && privateUnitsGroup.has(propertyData?.real_estate_kind);

  useEffect(() => {
    if (expandOne && expandTwo && expandThree && expandFour) {
      setExpandAll(true);
    } else {
      setExpandAll(false);
    }
  }, [expandOne, expandTwo, expandThree, expandFour]);

  return (
    <GridContainer>
      <BackButton onClick={navigateHome}>{IconArrowCircleLeftMS}</BackButton>
      <BoxContainer component="form" id="schedule" onSubmit={handleSubmit}>
        <Title
          osNumber={propertyData?.reference_number || 0}
          title={Constants.schedule}
          createdAt={propertyData?.created_at}
        />
        {isHiveOwner && propertyData && propertyData.hive_request && (
          <HiveDeadlineBar
            slaStatus={propertyData.sla_status}
            slaDaysElapsed={propertyData.sla_days_elapsed}
            slaDaysRemaining={propertyData.sla_days_remaining}
            requestCreatedAt={propertyData.hive_request.created_at}
            requestLimitDate={propertyData.hive_request.complete_until}
          />
        )}
        {isHiveOwner &&
          propertyData?.inspection_type === InspectionType.REMOTE &&
          propertyData.calendar_suggestions.length > 0 && (
            <>
              {propertyData.calendar_suggestions[0].status === 'PENDING' && (
                <Banner
                  severity="warning"
                  message={
                    <>
                      <strong
                        style={{
                          marginRight: '5px',
                        }}
                      >
                        Aguardando confirmação do agendamento da vistoria
                        virtual monitorada.
                      </strong>
                      O responsável ainda não confirmou presença. Confira mais
                      detalhes em
                    </>
                  }
                  linkText="Informações sobre agendamento"
                  linkUrl="#scheduling-information"
                />
              )}

              {propertyData.calendar_suggestions[0].status === 'APPROVED' && (
                <Banner
                  severity="success"
                  message={
                    <>
                      <strong
                        style={{
                          marginRight: '5px',
                          color: '#1A1A1A',
                          fontFamily: 'Roboto',
                          fontSize: '16px',
                        }}
                      >
                        Agendamento confirmado!
                      </strong>
                      A vistoria virtual monitorada será realizada no dia{' '}
                      <strong>
                        {' '}
                        {propertyData?.calendar_suggestions?.[0]?.schedule_at
                          .split('-')
                          .reverse()
                          .join('/')}
                      </strong>{' '}
                      às{' '}
                      <strong
                        style={{
                          color: '#1A1A1A',
                          fontFamily: 'Roboto',
                          fontSize: '16px',
                        }}
                      >
                        {propertyData?.calendar_suggestions?.[0]?.start_at}.
                      </strong>{' '}
                      O link da sala será disponibilizado 10 minutos antes do
                      horário agendado. Confira mais detalhes em
                    </>
                  }
                  linkText="Informações sobre aprovação"
                  linkUrl="#scheduling-information"
                />
              )}

              {propertyData.calendar_suggestions[0].status === 'REJECTED' && (
                <Banner
                  severity="error"
                  message={
                    <>
                      <strong
                        style={{
                          marginRight: '5px',
                        }}
                      >
                        Agendamento da vistoria virtual monitodada recusado.
                      </strong>
                      O responsável não poderá comparecer e o agendamento
                      precisa ser reavaliado. Confira mais detalhes em
                    </>
                  }
                  linkText="Informações sobre agendamento"
                  linkUrl="#scheduling-information"
                />
              )}
            </>
          )}
        {loadingPage ? (
          <LoadingBox>
            <ColoredCircularProgress />
          </LoadingBox>
        ) : (
          <>
            <FlexSpaceBetweenBox>
              <FlexBox>
                <CancelOsBox>
                  <ConfirmationDeleteDialog
                    iconCancel
                    title={Constants.cancelOs}
                    text={Constants.cancelOsText}
                    modalCallback={handleCancelWorkOrder}
                  />
                </CancelOsBox>
                {!isHiveOwner && (
                  <EditButton
                    disableTouchRipple
                    onClick={() => setEnableEditing(!enableEditing)}
                  >
                    {IconEditNoteMS}
                    {enableEditing ? Constants.cancelEdit : Constants.edit}
                  </EditButton>
                )}
              </FlexBox>
              <Box display="flex" gap={1.2}>
                {isHiveOwner && (
                  <MessagesDialog
                    osId={osId}
                    hiveRequest={propertyData?.hive_request || undefined}
                  />
                )}
                <AllAttachments propertyData={propertyData} osId={osId} />
              </Box>
            </FlexSpaceBetweenBox>
            <WorkOrderProgressBar complete>
              <>
                {enableEditing ? (
                  <SectionBox>
                    <SectionTitle>
                      {IconPersonMS}
                      {Constants.clientData}
                    </SectionTitle>
                    <Grid container spacing={4}>
                      <Grid item xs={6} xl={4}>
                        <CustomTextField
                          required
                          id="client"
                          label="proprietário do imóvel"
                          value={client}
                          setValue={setClient}
                        />
                      </Grid>
                      <Grid item xs={6} xl={4}>
                        <CustomTextField
                          id="solicitor"
                          label="solicitante"
                          value={solicitor}
                          setValue={setSolicitor}
                        />
                      </Grid>
                      <Grid item xs={6} xl={4}>
                        <SelectTextField
                          id="os-goal"
                          label="objetivo"
                          value={goal}
                          setValue={setGoal}
                          selectOptions={selectReportGoal()}
                        />
                      </Grid>
                      <Grid item xs={6} xl={3}>
                        <InputTitle>{Constants.evaluationType}</InputTitle>
                        <StyledInput>
                          {propertyData &&
                            convertEvaluationType(propertyData.evaluation_type)}
                        </StyledInput>
                      </Grid>
                      <Grid item xs={4} xl={3}>
                        <InputTitle>{Constants.clientType}</InputTitle>
                        <StyledInput>
                          {propertyData &&
                            convertClientKind(propertyData.client_kind)}
                        </StyledInput>
                      </Grid>
                      <Grid item xs={4} xl={3}>
                        <SelectTextField
                          id="os-function"
                          label="finalidade"
                          value={propertyFunction}
                          setValue={setPropertyFunction}
                          selectOptions={selectReportFunction()}
                        />
                      </Grid>
                      <Grid item xs={4} xl={3}>
                        <SelectTextField
                          id="property-use"
                          label="uso do imóvel"
                          value={propertyUse}
                          setValue={setPropertyUse}
                          selectOptions={selectPropertyUse()}
                        />
                      </Grid>
                    </Grid>
                  </SectionBox>
                ) : (
                  <ClientData propertyData={propertyData} />
                )}
                <ToogleAccordion expand={expandAll} toogle={toggleAccordions} />
              </>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete>
              <SectionBox>
                <AccordionTitle
                  title={Constants.propertyData}
                  icon={IconApartmentMS}
                  openAccordion={expandOne}
                  setOpenAccordion={setExpandOne}
                />
                {expandOne &&
                  (enableEditing ? (
                    <>
                      <Typography>{Constants.downloadText}</Typography>
                      <ButtonContainer>
                        <ButtonBox>
                          <ButtonTitle>
                            {Constants.propertyRegister}
                          </ButtonTitle>
                          {downloadRegister.length > 0 ? (
                            <DownloadButton
                              onClick={() => {
                                if (downloadRegister)
                                  handleDownloadFile(
                                    downloadRegister,
                                    'matricula'
                                  );
                              }}
                            >
                              {IconDownloadMS}
                              {Constants.download}
                            </DownloadButton>
                          ) : (
                            <>
                              <label htmlFor="uploadRegister">
                                <input
                                  accept="image/*,application/pdf"
                                  id="uploadRegister"
                                  type="file"
                                  style={{ display: 'none' }}
                                  onChange={async (
                                    e: ChangeEvent<HTMLInputElement>
                                  ) => handleFileUpload(e, 'register')}
                                />
                                <UploadButton
                                  variant="contained"
                                  component="span"
                                >
                                  {IconUploadMS}
                                  {Constants.upload}
                                </UploadButton>
                              </label>
                              {registerFileName && (
                                <Box mt={1}>{registerFileName}</Box>
                              )}
                            </>
                          )}
                        </ButtonBox>
                        <ButtonBox>
                          <ButtonTitle>{Constants.iptu}</ButtonTitle>
                          {downloadIptu.length > 0 ? (
                            <DownloadButton
                              onClick={() => {
                                if (downloadIptu)
                                  handleDownloadFile(downloadIptu, 'iptu');
                              }}
                            >
                              {IconDownloadMS}
                              {Constants.download}
                            </DownloadButton>
                          ) : (
                            <>
                              <label htmlFor="uploadIptu">
                                <input
                                  accept="image/*,application/pdf"
                                  id="uploadIptu"
                                  type="file"
                                  style={{ display: 'none' }}
                                  onChange={async (
                                    e: ChangeEvent<HTMLInputElement>
                                  ) => handleFileUpload(e, 'iptu')}
                                />
                                <UploadButton
                                  variant="contained"
                                  component="span"
                                >
                                  {IconUploadMS}
                                  {Constants.upload}
                                </UploadButton>
                              </label>
                              {iptuFileName && <Box mt={1}>{iptuFileName}</Box>}
                            </>
                          )}
                        </ButtonBox>
                      </ButtonContainer>
                      <Grid container spacing={4}>
                        <Grid item xs={3}>
                          <CustomTextField
                            required
                            id="register-number"
                            label="nº da matrícula"
                            value={registerNumber}
                            setValue={setRegisterNumber}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <CustomTextField
                            required
                            id="registry-office"
                            label="código do cartório (cns)"
                            value={registryOffice}
                            setValue={setRegistryOffice}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <CustomTextField
                            required
                            id="register-number"
                            label="livro de registro"
                            value={book}
                            setValue={setBook}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <InputTitle>tipo do imóvel:</InputTitle>
                          <StyledInput>
                            {propertyData &&
                              convertPropertyType(
                                propertyData.real_estate_kind
                              )}
                          </StyledInput>
                        </Grid>
                        <Grid item xs={3}>
                          <SelectTextField
                            id="concept"
                            label="conceito do espaço"
                            value={concept}
                            setValue={setConcept}
                            selectOptions={selectConcept()}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <NumericTextField
                            id="zone"
                            label="ofício/zona"
                            suffix=""
                            maxLength={12}
                            value={zone}
                            setValue={setZone}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <CustomTextField
                            required
                            id="judicial-district"
                            label="comarca"
                            value={judicialDistrict}
                            setValue={setJudicialDistrict}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <SelectTextField
                            id="registration-uf"
                            label="UF"
                            value={registrationUf}
                            setValue={setRegistrationUf}
                            selectOptions={selectRegistrationUf()}
                          />
                        </Grid>
                      </Grid>
                    </>
                  ) : (
                    <PropertyData propertyData={propertyData} />
                  ))}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete>
              <SectionBox>
                <AccordionTitle
                  title={Constants.propertyAddress}
                  icon={IconLocationOnMS}
                  openAccordion={expandTwo}
                  setOpenAccordion={setExpandTwo}
                />
                {expandTwo &&
                  (enableEditing ? (
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <CustomTextField
                              required
                              id="address"
                              label="logradouro"
                              value={address}
                              setValue={setAddress}
                              onChange={setIsAddressEdited}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomTextField
                              required
                              id="address-number"
                              label="número"
                              disabled={isWithoutNumber}
                              value={addressNumber}
                              setValue={setAddressNumber}
                              onChange={setIsAddressEdited}
                            />
                          </Grid>
                          <Grid item xs={3} mt="6px">
                            <FormControlLabel
                              id="without-number"
                              label="Sem número"
                              control={
                                <Checkbox
                                  name="without-number"
                                  checked={isWithoutNumber}
                                  onChange={(event) => {
                                    setIsWithoutNumber(event.target.checked);
                                    setIsAddressEdited(true);
                                    if (event.target.checked)
                                      setAddressNumber('');
                                  }}
                                />
                              }
                              sx={{
                                '& .MuiTypography-root': {
                                  fontSize: '14px',
                                  lineHeight: 1.2,
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={5}>
                            <CustomTextField
                              id="complement"
                              label="complemento"
                              value={complement}
                              setValue={setComplement}
                              onChange={setIsAddressEdited}
                            />
                          </Grid>
                          <Grid item xs={7}>
                            <CustomTextField
                              required
                              id="district"
                              label="bairro"
                              value={district}
                              setValue={setDistrict}
                              onChange={setIsAddressEdited}
                            />
                          </Grid>
                          <Grid item xs={5}>
                            <PatternFormat
                              required
                              format="#####-###"
                              customInput={StyledTextField}
                              id="cep"
                              label="CEP"
                              value={cep}
                              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                verifyCep(e.target.value)
                              }
                              sx={CepStyle}
                            />
                          </Grid>
                          <Grid item xs={7}>
                            <CustomTextField
                              required
                              id="city"
                              label="cidade"
                              value={city}
                              setValue={setCity}
                              onChange={setIsAddressEdited}
                            />
                          </Grid>
                          <Grid item xs={5}>
                            <CustomTextField
                              required
                              id="uf"
                              label="estado"
                              value={uf}
                              setValue={setUf}
                              onChange={setIsAddressEdited}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <MapSearchButton
                              cep={cep}
                              address={address}
                              addressNumber={addressNumber}
                              district={district}
                              city={city}
                              uf={uf}
                              isWithoutNumber={isWithoutNumber}
                              hasSearched={hasSearched}
                              isAddressEdited={isAddressEdited}
                              labels={{
                                searchMap: Constants.searchMap,
                                mapUpdated: Constants.mapUpdated,
                                fieldsIncomplete: Constants.fieldsIncomplete,
                              }}
                              onClick={() => {
                                setSearchMap(!searchMap);
                                setIsAddressEdited(false);
                                setHasSearched(true);
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={6}>
                        <StandardMap
                          searchMap={searchMap}
                          address={`${address} ${addressNumber}`}
                          district={district}
                          city={city}
                          uf={uf}
                          pinPlace={pinPlace}
                          setPinPlace={setPinPlace}
                          showCoords
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <PropertyAddressWithMaps propertyData={propertyData} />
                  ))}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete>
              <SectionBox>
                <AccordionTitle
                  title={Constants.propertyDetails}
                  icon={IconLocationCityMS}
                  openAccordion={expandThree}
                  setOpenAccordion={setExpandThree}
                />
                {expandThree &&
                  (enableEditing ? (
                    <Grid container spacing={4}>
                      <Grid item xs={2}>
                        <NumericTextField
                          id="total-area"
                          label={
                            isPrivateUnit ? 'área total' : 'área do terreno'
                          }
                          suffix=" m²"
                          decimalSeparator=","
                          decimalScale={2}
                          maxLength={18}
                          value={totalArea}
                          setValue={setTotalArea}
                        />
                      </Grid>
                      {!isParcelGroup && (
                        <>
                          <Grid item xs={2}>
                            <NumericTextField
                              id="built-area"
                              label={
                                isPrivateUnit
                                  ? 'área privativa'
                                  : 'área construída'
                              }
                              suffix=" m²"
                              decimalSeparator=","
                              decimalScale={2}
                              maxLength={18}
                              value={builtArea}
                              setValue={setBuiltArea}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <NumericTextField
                              id="rooms"
                              label="quartos"
                              suffix=" quartos"
                              maxLength={12}
                              value={propertyRooms}
                              setValue={setPropertyRooms}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <NumericTextField
                              id="toilets"
                              label="banheiros"
                              suffix=" banheiros"
                              maxLength={13}
                              value={toilets}
                              setValue={setToilets}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <NumericTextField
                              id="suites"
                              label="suítes"
                              suffix=" suítes"
                              maxLength={10}
                              value={suites}
                              setValue={setSuites}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <NumericTextField
                              id="parking-lots"
                              label="vagas de garagem"
                              suffix=" vagas"
                              maxLength={9}
                              value={parkingLots}
                              setValue={setParkingLots}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <NumericTextField
                              id="propertyAge"
                              label="idade do imóvel"
                              suffix=" anos"
                              maxLength={9}
                              value={age}
                              setValue={setAge}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <SelectTextField
                              id="conservation"
                              label="estado de conservação do imóvel"
                              value={conservation}
                              setValue={setConservation}
                              selectOptions={selectConservation()}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <SelectTextField
                              id="building-standard"
                              label="padrão construtivo"
                              value={buildingStandard}
                              setValue={setBuildingStandard}
                              selectOptions={selectStandard()}
                            />
                          </Grid>
                        </>
                      )}
                    </Grid>
                  ) : (
                    <PropertyInfo propertyData={propertyData} />
                  ))}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete={completeScheduling} lastAccordion>
              <SectionBox>
                <AccordionTitle
                  title={Constants.schedulingInformations}
                  icon={IconCalendarTodayMS}
                  openAccordion={expandFour}
                  setOpenAccordion={setExpandFour}
                />

                {expandFour &&
                  (isHiveOwner ? (
                    <Box>
                      {isHiveOwner &&
                        propertyData?.calendar_suggestions &&
                        propertyData.calendar_suggestions.length > 0 && (
                          <RemoteInspectionTableHistory
                            rows={propertyData?.calendar_suggestions}
                          />
                        )}
                      {propertyData?.inspection?.schedule_at ? (
                        <ScheduleInfo
                          inspectionData={propertyData.inspection}
                          showDownload={false}
                          responsibleEmail={
                            isHiveOwner &&
                            propertyData.calendar_suggestions.length > 0
                              ? propertyData.calendar_suggestions[0]
                                  .responsible_email
                              : undefined
                          }
                          workerCompanyId={
                            propertyData.worker_company_id || undefined
                          }
                        />
                      ) : (
                        <Typography>{Constants.noInspection}</Typography>
                      )}
                    </Box>
                  ) : (
                    <Grid container spacing={2}>
                      <Grid item xs={4}>
                        <StyledTextField
                          id={osId.toString()}
                          select
                          label={Constants.inspector}
                          value={engineer}
                          onChange={(e) => {
                            getEngineerEvents(Number(e.target.value), today[0]);
                            setEngineer(Number(e.target.value));
                          }}
                          sx={{ minWidth: '350px' }}
                        >
                          <MenuItem disabled value={0}>
                            {Constants.selectInspector}
                          </MenuItem>
                          {usersData?.map((option) => (
                            <MenuItem
                              key={option.id}
                              value={option.id}
                              sx={(theme) => ({
                                '&:hover': {
                                  backgroundColor: '#EDEDED',
                                },
                                '&.Mui-selected': {
                                  backgroundColor: alpha(
                                    theme.palette.common.grey,
                                    0.3
                                  ),
                                  '&:hover': {
                                    backgroundColor: alpha(
                                      theme.palette.common.grey,
                                      0.3
                                    ),
                                  },
                                },
                              })}
                            >
                              {option.name}
                            </MenuItem>
                          ))}
                        </StyledTextField>
                      </Grid>
                      <Grid item xs={12} />
                      <Grid item xs={4}>
                        <StyledTextField
                          required
                          id="responsible"
                          label={Constants.responsible}
                          value={responsibleName}
                          placeholder={Constants.placeholderResponsible}
                          onChange={(e) => {
                            setResponsibleName(e.target.value);
                          }}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <StyledTextField
                          id="cellphone"
                          label="contato"
                          placeholder="Digite o contato"
                          inputProps={{ maxLength: 15 }}
                          value={contact}
                          onChange={(e: ChangeEvent<HTMLInputElement>) =>
                            setContact(formatPhone(e.target.value))
                          }
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopDatePicker
                            label={Constants.date}
                            value={date}
                            format="DD-MM-YYYY"
                            disablePast
                            slotProps={{
                              textField: {
                                sx: textFieldDefaultStyle,
                              },
                            }}
                            onChange={(e) => setDate(e)}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={2}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopTimePicker
                            label={Constants.beggining}
                            value={startTime}
                            ampm={false}
                            slotProps={{
                              textField: {
                                sx: textFieldDefaultStyle,
                              },
                            }}
                            onChange={handleStartTime}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={2}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopTimePicker
                            label={Constants.end}
                            value={endTime}
                            ampm={false}
                            slotProps={{
                              textField: {
                                sx: textFieldDefaultStyle,
                              },
                            }}
                            onChange={handleEndTime}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={12}>
                        <OutlineButton
                          onClick={() => handleSchedule(hasSchedule)}
                        >
                          {hasSchedule
                            ? Constants.editSchedule
                            : Constants.createSchedule}
                        </OutlineButton>
                      </Grid>
                      {scheduledData && (
                        <Grid item xs={12}>
                          <Calendar
                            scheduledData={scheduledData}
                            eng={engineer}
                            callback={getEngineerEvents}
                          />
                        </Grid>
                      )}
                    </Grid>
                  ))}
              </SectionBox>
            </WorkOrderProgressBar>
            <AssociatedWorkOrders osId={osId} />
            {!isHiveOwner && (
              <SubmitBox>
                <PeptDialog
                  osId={osId}
                  referenceNumber={propertyData?.reference_number}
                />
                {enableEditing ? (
                  <ConfirmEditButton form="schedule" type="submit">
                    {Constants.confirmEdit}
                  </ConfirmEditButton>
                ) : (
                  <ConfirmationDialog
                    title={Constants.approve}
                    loading={loadingApprove}
                    text={Constants.changeStatus.replace(
                      '**',
                      `${propertyData?.reference_number}`
                    )}
                    modalCallback={() => {
                      setLoadingApprove(true);
                      handleScheduleExist()
                        ? handleStatus(osId, propertyData?.reference_number)
                        : setLoadingApprove(false);
                    }}
                  />
                )}
              </SubmitBox>
            )}
          </>
        )}
      </BoxContainer>
      {openSnackbar && <Snackbar />}
    </GridContainer>
  );
}
